import React from 'react';
import { useDispatch } from 'react-redux';
import { NavTextButton } from '../../components/NavBar';
import { displayInformationAlert } from '../../helpers/Functions';
import { Snippet } from '../../services/dataModels';
import { editingActions, shiftLogActions } from '../../store';
import { AppDispatch } from '../../store/store';

interface SaveButtonProps {
  snippet: Snippet | (() => Snippet);
  onSuccess?: () => void;
  disable?: boolean;
}

const SaveButton = ({ snippet, onSuccess, disable }: SaveButtonProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const showLogUpdateSuccessAlert = () => {
    displayInformationAlert({
      title: 'Successfully Updated',
      description: 'The shift log has been successfully updated.',
    });
  };

  const handleSavePressed = () => {
    dispatch(
      editingActions.editedSnippetChanged(typeof snippet === 'function' ? snippet() : snippet),
    );
    dispatch(shiftLogActions.updateShiftLog()).then((response) => {
      if (shiftLogActions.updateShiftLog.fulfilled.match(response)) {
        onSuccess?.();
        showLogUpdateSuccessAlert();
      }
    });
  };

  return <NavTextButton text="Save" onPress={handleSavePressed} disabled={disable} />;
};

export default SaveButton;
